import React, { useState, useEffect } from "react";
import Register from "../Assets/Login_Register/Regiter.png";
import axios from "axios";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function MainLogin() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [selection, setSelection] = useState("");
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    password: "",
    confirmPassword: "",
    mobileNumber: "",
    currentCity: "",
    resume: null,
  });
  const [errors, setErrors] = useState({});
  const [otp, setOtp] = useState(""); // For OTP input
  const [isOtpSent, setIsOtpSent] = useState(false); // OTP step flag
  const [email, setEmail] = useState(""); // Store email for OTP verification
  const [captcha, setCaptcha] = useState({ num1: 0, num2: 0, answer: "" });
  const [captchaError, setCaptchaError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  const generateCaptcha = () => {
    const num1 = Math.floor(Math.random() * 10) + 1;
    const num2 = Math.floor(Math.random() * 10) + 1;
    setCaptcha({ num1, num2, answer: "" });
  };

  const handleCaptchaChange = (e) => {
    setCaptcha({ ...captcha, answer: e.target.value });
    setCaptchaError("");
  };

  const validateCaptcha = () => {
    if (parseInt(captcha.answer) !== captcha.num1 + captcha.num2) {
      setCaptchaError("Incorrect CAPTCHA. Please try again.");
      generateCaptcha();
      return false;
    }
    return true;
  };

  const togglePasswordVisibility = () => setShowPassword((prev) => !prev);
  const toggleConfirmPasswordVisibility = () => setShowConfirmPassword((prev) => !prev);

  /* Registration API */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm() && validateCaptcha()) {
      const formDataToSend = new FormData();
      formDataToSend.append("email", formData.email);
      formDataToSend.append("password", formData.password);
      formDataToSend.append("confirm_password", formData.confirmPassword);
      formDataToSend.append("profile.full_name", formData.fullName);
      formDataToSend.append("profile.mobile_number", formData.mobileNumber);
      formDataToSend.append("profile.work_status", selection);
      formDataToSend.append("profile.resume", formData.resume);
      formDataToSend.append("profile.current_city", formData.currentCity);

      try {
        setIsLoading(true);
        const response = await axios.post(
          "http://127.0.0.1:8000/homeRegistration/register/",
          formDataToSend,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        alert(response.data.message);
        setEmail(formData.email);
        setIsOtpSent(true); // Proceed to OTP step
      } catch (error) {
        handleApiErrors(error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  /* OTP Verification API */
  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "http://127.0.0.1:8000/homeRegistration/verify-otp/",
        { email, otp }
      );

      alert(response.data.message);
      window.location.href = "/Dashboard"; // Redirect to profile
    } catch (error) {
      handleApiErrors(error);
    }
  };

  const handleApiErrors = (error) => {
    if (error.response) {
      console.error("Error Data:", error.response.data);
      alert(error.response.data.message || "An error occurred.");
    } else if (error.request) {
      console.error("No Response Received:", error.request);
      alert("No response received from the server.");
    } else {
      console.error("Error Message:", error.message);
      alert("An unexpected error occurred.");
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.fullName) newErrors.fullName = "Full Name is required.";
    if (!formData.email) newErrors.email = "Email is required.";
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = "Enter a valid email.";
    if (!formData.password) newErrors.password = "Password is required.";
    else if (formData.password.includes(" "))
      newErrors.password = "Spaces are not allowed in the password.";
    else if (formData.password.length < 6)
      newErrors.password = "Password must be at least 6 characters.";
    if (formData.password !== formData.confirmPassword)
      newErrors.confirmPassword = "Passwords do not match.";
    if (!formData.mobileNumber) newErrors.mobileNumber = "Mobile Number is required.";
    else if (!/^\+?\d{10,15}$/.test(formData.mobileNumber))
      newErrors.mobileNumber = "Enter a valid mobile number.";
    if (selection === "experienced" && !formData.resume)
      newErrors.resume = "Resume is required.";
    if (selection === "fresher" && !formData.currentCity)
      newErrors.currentCity = "Current City is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return (
    <div className="bg-gray-100 w-full flex justify-center items-center min-h-screen">
      <div className="bg-white w-full max-w-7xl rounded-3xl flex overflow-hidden my-10 shadow-lg">
        {/* Image */}
        <div className="hidden md:flex flex-col justify-center items-center w-1/3 p-6">
          <div className="flex flex-col items-center justify-center border-2 border-[#0077af] bg-white px-8 py-6 rounded-lg mb-6 w-[350px] h-[150px]">
            <p className="text-gray-500 text-sm mb-4 font-bold">Already Registered?</p>
            <button
              className="bg-[#0077af] px-6 py-2 rounded-3xl text-white font-bold"
              onClick={() => (window.location.href = "/homelogin")}
            >
              Login
            </button>
          </div>
          <img
            src={Register}
            alt="Register"
            className="w-[450px] h-[450px] object-contain mt-0"
          />
        </div>

        {/* Right Section - Form */}
        <div className="p-10 text-black flex flex-col justify-center items-start gap-8 w-full md:w-1/2">
          {!isOtpSent ? (
            <>
              <div className="flex items-center justify-between w-full ">
                <h1 className="text-2xl font-medium">Create your Jobgenee Profile</h1>
                <div className="flex justify-between items-center">
                  <span></span> {/* Empty span to create space on the left */}
                  <button
                    onClick={() => navigate("/")} // Navigate back
                    className="flex items-center text-gray-300 hover:text-red-600 transition-colors duration-300"
                  >
                    <FaTimes className="mr-2" />
                  </button>
                </div>
              </div>
              <p className="text-gray-500 text-sm">
                Search & apply to jobs from India's No.1 Job Site
              </p>
              <form
                className="flex flex-col justify-start items-start gap-6 w-full"
                onSubmit={handleSubmit}
              >
                {/* Full Name */}
                <div className="w-full">
                  <label>
                    Full Name<span className="text-red-500"> *</span>
                  </label>
                  <input
                    type="text"
                    name="fullName"
                    placeholder="What is your name?"
                    value={formData.fullName}
                    onChange={handleChange}
                    className="border-gray-400 border-[1px] rounded-xl px-2 py-2 w-full"
                  />
                  {errors.fullName && (
                    <p className="text-red-500 text-sm">{errors.fullName}</p>
                  )}
                </div>

                {/* Email */}
                <div className="w-full">
                  <label>
                    Email Id<span className="text-red-500"> *</span>
                  </label>
                  <input
                    type="text"
                    name="email"
                    placeholder="Write your Email Id"
                    value={formData.email}
                    onChange={handleChange}
                    className="border-gray-400 border-[1px] rounded-xl px-2 py-2 w-full"
                  />
                  <p className="text-xs text-gray-400">
                    We'll send relevant jobs and updates to this email
                  </p>
                  {errors.email && (
                    <p className="text-red-500 text-sm">{errors.email}</p>
                  )}
                </div>

                {/* Password and Confirm Password in Half-Half Layout */}
                <div className="w-full grid grid-cols-2 gap-6">
                  {/* Password */}
                  <div>
                    <label>
                      Password<span className="text-red-500"> *</span>
                    </label>
                    <div className="relative w-full">
                      <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        placeholder="(Minimum 6 characters)"
                        value={formData.password}
                        onChange={handleChange}
                        className="border-gray-400 border-[1px] rounded-xl px-2 py-2 w-full pr-12"
                      />
                      <button
                        type="button"
                        onClick={togglePasswordVisibility}
                        className="absolute inset-y-0 right-3 flex items-center text-gray-500"
                      >
                        {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                      </button>
                    </div>
                    {errors.password && (
                      <p className="text-red-500 text-sm">{errors.password}</p>
                    )}
                  </div>

                  {/* Confirm Password */}
                  <div>
                    <label>
                      Confirm Password<span className="text-red-500"> *</span>
                    </label>
                    <div className="relative w-full">
                      <input
                        type={showConfirmPassword ? "text" : "password"}
                        name="confirmPassword"
                        placeholder="Re-write your password"
                        value={formData.confirmPassword}
                        onChange={handleChange}
                        className="border-gray-400 border-[1px] rounded-xl px-2 py-2 w-full pr-12"
                      />
                      <button
                        type="button"
                        onClick={toggleConfirmPasswordVisibility}
                        className="absolute inset-y-0 right-3 flex items-center text-gray-500"
                      >
                        {showConfirmPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                      </button>
                    </div>
                    {errors.confirmPassword && (
                      <p className="text-red-500 text-sm">{errors.confirmPassword}</p>
                    )}
                  </div>
                </div>

                {/* Mobile Number */}
                <div className="w-full">
                  <label>
                    Mobile Number<span className="text-red-500"> *</span>
                  </label>
                  <input
                    type="text"
                    name="mobileNumber"
                    placeholder="+91 Enter your mobile number"
                    value={formData.mobileNumber}
                    onChange={handleChange}
                    className="border-gray-400 border-[1px] rounded-xl px-2 py-2 w-full"
                  />
                  <p className="text-xs text-gray-400">
                    Recruiters will contact you on this number
                  </p>
                  {errors.mobileNumber && (
                    <p className="text-red-500 text-sm">
                      {errors.mobileNumber}
                    </p>
                  )}
                </div>

                {/* Work Status Selection */}
                <div className="w-full">
                  <label>Work Status</label>
                  <div className="grid grid-cols-2 gap-12">
                    <button
                      type="button"
                      onClick={() => setSelection("experienced")}
                      className={`p-4 text-center font-medium border rounded-lg ${selection === "experienced"
                        ? "border-2 border-black"
                        : "bg-white text-gray-800 border-gray-300"
                        }`}
                    >
                      I'm Experienced
                      <p className="text-sm text-gray-600">
                        I have work experience (excluding internships)
                      </p>
                    </ button>
                    <button
                      type="button"
                      onClick={() => setSelection("fresher")}
                      className={`p-4 text-center font-medium border rounded-lg ${selection === "fresher"
                        ? "border-2 border-black"
                        : "bg-white text-gray-800 border-gray-300"
                        }`}
                    >
                      I'm a Fresher
                      <p className="text-sm text-gray-600">
                        I am a student/ Haven't worked after graduation
                      </p>
                    </button>
                  </div>
                </div>

                {/* Upload Resume and Select Your Current City (Side-by-side) */}
                <div className="mt-6 grid grid-cols-2 gap-4 w-full">
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">
                      Upload Resume<span className="text-red-500"> *</span>
                    </label>
                    <input
                      type="file"
                      name="resume"
                      onChange={handleChange}
                      className="w-full p-2 border rounded-lg"
                    />
                    {errors.resume && (
                      <p className="text-red-500 text-sm">{errors.resume}</p>
                    )}
                  </div>

                  <div>
                    <label className="block text-gray-700 font-medium mb-2">
                      Select Your Current City<span className="text-red-500"> *</span>
                    </label>
                    <input
                      type="text"
                      name="currentCity"
                      placeholder="Enter current city"
                      value={formData.currentCity}
                      onChange={handleChange}
                      className="w-full p-2 border rounded-lg"
                    />
                    {errors.currentCity && (
                      <p className="text-red-500 text-sm">{errors.currentCity}</p>
                    )}
                  </div>
                </div>

                {/* Captcha */}
                <div>
                  <label className="text-gray-800 text-sm mb-2 block font-bold">CAPTCHA</label>
                  <div className="flex items-center space-x-2 border border-gray-300 rounded-lg p-3 shadow-sm bg-gray-50">
                    <span className="text-gray-800 font-bold">{`${captcha.num1} + ${captcha.num2} = `}</span>
                    <input
                      type="number"
                      value={captcha.answer}
                      onChange={handleCaptchaChange}
                      className="w-16 text-center text-sm text-gray-800 border border-gray-300 px-2 py-2 rounded-lg outline-none focus:ring-2 focus:ring-[#0077af]"
                      placeholder="?"
                      required
                    />
                  </div>
                  {captchaError && <p className="text-red-600 text-sm mt-1">{captchaError}</p>}
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  className="bg-blue-600 px-6 py-3 rounded-3xl text-white w-full"
                  disabled={isLoading}
                >
                  {isLoading ? "Registering..." : "Register"}
                </button>
              </form>
            </>
          ) : (
            <>
              <h1 className="text-2xl font-medium">Verify OTP</h1>
              <form onSubmit={handleOtpSubmit}>
                <div className="w-full">
                  <label>
                    OTP<span className="text-red-500"> *</span>
                  </label>
                  <input
                    type="text"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    className="border-gray-400 border-[1px] rounded-xl px-2 py-2 w-full"
                    placeholder="Enter the OTP sent to your email"
                  />
                </div>
                <button
                  type="submit"
                  className="bg-blue-600 px-6 py-3 rounded-3xl text-white w-full mt-4"
                >
                  Verify OTP
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}